module.exports = __webpack_public_path__ + "img/syukyaku-top-014.e2d96610.jpg";